import useDebounce from 'shared_DEPRECATED/hooks/useDebounce';

import { useLinkPreviewQuery } from 'shared/hooks/query/useLinkPreview';
import { extractLinksFromString } from 'shared/utils/links';

type useGetLinkPreviewProps = {
  text: string;
};

const DEBOUNCE_TIMEOUT = 200;

export const useGetFirstLinkPreview = ({ text }: useGetLinkPreviewProps) => {
  const links = extractLinksFromString(text);
  const [firstLink] = links;

  const debouncedLink = useDebounce(firstLink, DEBOUNCE_TIMEOUT);

  const { data: linkPreview } = useLinkPreviewQuery({
    url: debouncedLink,
  });

  return linkPreview;
};
